import { render, staticRenderFns } from "./FontStyleButton.vue?vue&type=template&id=3d655a07&scoped=true&"
import script from "./FontStyleButton.vue?vue&type=script&lang=js&"
export * from "./FontStyleButton.vue?vue&type=script&lang=js&"
import style0 from "./FontStyleButton.vue?vue&type=style&index=0&id=3d655a07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d655a07",
  null
  
)

export default component.exports